export const testNumberRegex = (val) => {
  const re = /^[0-9\b]+$/;
  if (val === "" || re.test(val)) return true;
  return false;
};
